<template>
  <div>
    <v-card
      tile
      elevation="0"
      class="d-flex flex-column justify-center py-12"
      :min-height="settings.bg && settings.bg.height ? settings.bg.height : '700px'"
      :color="MIXIN_getBgInfo(settings, 'color')"
      :img="MIXIN_getBgInfo(settings, 'image')"
    >
      <v-container style="max-width: 1340px">
        <v-row 
          :class="[{'px-12': $vuetify.breakpoint.mdAndUp}, {'px-4': !$vuetify.breakpoint.mdAndUp}]" 
          justify="center" 
          no-gutters
          :style="`${$vuetify.breakpoint.mdAndUp && settings['text-position'] === 'right' ? 'flex-direction: row-reverse !important' : ''}`"
        >
          <v-col 
            :class="
              [
                {'pr-8': $vuetify.breakpoint.mdAndUp && settings['text-position'] === 'left'}, 
                {'pl-8': $vuetify.breakpoint.mdAndUp && settings['text-position'] === 'right'}, 
                {'pb-5 text-center': !$vuetify.breakpoint.mdAndUp || settings['text-position'] === 'center'}
              ]
            " 
            :cols="!$vuetify.breakpoint.mdAndUp || settings['text-position'] === 'center' ? '12' : '6'"
          >
            <h1
              class="pb-4"
              :style="
                `
                font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; 
                font-size: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
                color: ${MIXIN_getStyle(settings, 'title', 'color')} !important; 
                line-height: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'title', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'title', 'font-style')} !important;
                `
              "
            >
              {{ settings.title.content }}
            </h1>

            <span
              :style="
                `
                font-family: ${MIXIN_getStyle(settings, 'subtitle', 'font')} !important; 
                font-size: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
                color: ${MIXIN_getStyle(settings, 'subtitle', 'color')} !important; 
                line-height: ${MIXIN_getStyle(settings, 'subtitle', 'font-size')} !important; 
                font-weight: ${MIXIN_getStyle(settings, 'subtitle', 'weight')} !important;
                font-style: ${MIXIN_getStyle(settings, 'subtitle', 'font-style')} !important;
                `
              "
              v-html="settings.subtitle.content"
            ></span>

            <div
              class="text-font"
              :style="
                `
                padding-top: 16px;
                `
              "
              v-html="formatedText"
            ></div>
          </v-col>

          <v-col :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'">
            <v-card 
              :color="settings['layer-color']" 
              :class="['rounded-xl pa-12']" 
              elevation="0"
            >
              <v-row v-for="(item, i) in settings.items" :key="i" justify="center" align="center">
                <div v-if="item.type === 'text'" style="width: 100%">
                  <span 
                    class="item-title mb-4" 
                    :style="
                      `
                      font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                      font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                      color: ${settings['text-color']} !important; 
                      `
                    "
                  >
                    {{item.caption}}
                  </span>
                  <v-text-field outlined color="grey" background-color="white" v-model="name"></v-text-field>
                </div>
                <div v-if="item.type === 'email'" style="width: 100%">
                  <span
                    class="item-title mb-4"
                    :style="
                      `
                      font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                      font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                      color: ${settings['text-color']} !important; 
                      `
                    "
                  >
                    {{item.caption}}
                  </span>
                  <v-text-field
                    :rules="[rules.email]"
                    outlined
                    color="grey"
                    background-color="white"
                    v-model="email"
                  />
                </div>
                <div v-if="item.type === 'phone'" style="width: 100%">
                  <span
                    class="item-title mb-4"
                    :style="
                      `
                      font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                      font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                      color: ${settings['text-color']} !important; 
                      `
                    "
                  >
                  {{item.caption}}
                  </span>
                  <v-text-field
                    outlined
                    color="grey"
                    background-color="white"
                    v-mask="phone.length <= 14 ? maskPhone : maskCellPhone"
                    v-model="phone"
                  ></v-text-field>
                </div>
                <div v-if="item.type === 'long-text'" style="width: 100%">
                  <span
                    class="item-title mb-4"
                    :style="
                      `
                      font-family: ${MIXIN_getStyle(settings, 'text', 'font')} !important; 
                      font-size: ${MIXIN_getStyle(settings, 'text', 'font-size')} !important; 
                      color: ${settings['text-color']} !important; 
                      `
                    "
                  >
                    {{item.caption}}
                  </span>
                  <v-textarea
                    outlined
                    auto-grow
                    color="grey"
                    background-color="white"
                    v-model="message"
                  />
                </div>
                <v-btn
                  elevation="0"
                  dark
                  :style="
                    `
                    background-color: ${MIXIN_getStyle(settings, 'button', 'background-color', 0)} !important;
                    border-radius: ${MIXIN_getStyle(settings, 'button', 'border-radius', 0)} !important
                    `
                  "
                  v-if="item.type === 'submit'"
                  width="100%"
                  @click="submitContact"
                >
                  <b 
                    :style="
                      `
                      color: ${MIXIN_getStyle(settings, 'button', 'color', 0)} !important;
                      `
                    "
                  >
                    {{ item.caption }}
                  </b>
                </v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog v-model="dialogMessage" width="600px" persistent>
      <dialog-message v-if="dialogMessage" @close="closeDialog" />
    </v-dialog>
  </div>
</template>

<script>
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection";
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import DialogMessage from "./DialogMessage";

export default {
  mixins: [GetLayoutSectionMixin],
  components: { DialogMessage },
  directives: { mask },
  props: {
    settings: {type: Object},
  },

  data() {
    return {
      maskPhone: "(##) ####-####",
      maskCellPhone: "(##) #####-####",
      settingsTitle: null,
      dialogMessage: false,
      name: "",
      message: "",
      hover: false,
      email: "",
      phone: "",

      rules: {
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail Inválido.";
        },
      },
    };
  },

  computed: {
    ...mapGetters(["infos"]),
    alignCenter() {
      if (this.settings["text-position"] === "center") return true;
      else false;
    },

    formatedText() {
      if (this.settings.text.content) {
        let content = this.settings.text.content 
        if (!content.includes('<p>') && !content.includes('</p>')) content = `<p>${content}</p>`
        const formated = content
          .replaceAll(
            '<p>',
            `<span style="
              display: block;
              font-family: ${this.MIXIN_getStyle(this.settings, 'text', 'font')} !important; 
              font-size: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              color: ${this.MIXIN_getStyle(this.settings, 'text', 'color')} !important; 
              line-height: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              font-weight: ${this.MIXIN_getStyle(this.settings, 'text', 'weight')} !important;
              font-style: ${this.MIXIN_getStyle(this.settings, 'text', 'font-style')} !important;
            ">`
          )
          .replaceAll('</p>', "</span>")
        return formated
      } else return ""
    }   
  },

  created() {
    this.settingsTitle = {
      title: this.settings.title,
      subtitle: this.settings.subtitle,
      "background-color": "transparent",
    };
  },

  methods: {
    async submitContact() {
      await this.$store.dispatch("postMessage", {
        id: this.infos["organizer-id"],
        name: this.name,
        email: this.email,
        phone: this.phone,
        message: this.message,
      });
      this.dialogMessage = true;
      this.clearForm();
    },

    closeDialog() {
      this.dialogMessage = false;
    },

    clearForm() {
      this.name = "";
      this.email = "";
      this.phone = "";
      this.message = "";
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0px;
}

span {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
}

.v-btn {
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.75px;
  text-align: center;
}

.item-title {
  font-size: 16px;
}

.text-font p {
  font-family: inherit !important;
}
</style>